<template>
  <skud-point-list />
</template>

<script>
import SkudPointList from '@/views/skud/components/SkudPointList.vue'

export default {
  name: 'SkudPointListPage',
  components: { SkudPointList }
}
</script>
